/*
    Every element should have a SearchText:  (string) and Discount (0 <= x < 1.0) property
    but some elements might have additional optional parameters:
    
    MinOrder: a string listing the minimum order amount and any other restrictions
    PromptForListPrice: CSRs normally enter Cost unless this boolean is true
    EndUserMarkup,
    DealerMarkup,
    WholesalerMarkup: Markups are usually calculated dynamically, but when present,
                      these override markups are used instead
 */
const vendors = [
  {
    SearchText: ">>> Non-Standard Vendor",
    Discount: 0.5,
    Tariff: "Enter a tariff percentage below if the the tariff is in addition to the quoted cost."
  },
  {
    SearchText: "Admiral Craft",
    Discount: 0.5,
    Note: "Enter quoted price as COST even though the quote refers to it as List"
  },
  {
    SearchText: "AHT Cooling Systems",
    Discount: 0.5,
    Tariff: "15% tariff charge on all parts orders"
  },
  {
    SearchText: "American Biotech / Horizon Scientific",
    Discount: 0.0
  },
  {
    SearchText: "American Panel",
    Discount: 0.5
  },
  {
    SearchText: "Anthony",
    Discount: 0.5,
    MinOrder: "$35",
    Tariff: "For Anthony International customers, effective for all orders placed on or after April 1, 2025, the following temporary surcharges will apply:\n\nPackage doors/frames with/without shelving: 2.4%%\nOEM doors/frames: 2.4%%\nReplacement doors/frames: 2.4%%\nAftermarket LED Replacements & Retrofit Kits: 20%%\nAftermarket Hold Opens: 10%%\n\nAdditionally, beginning March 19th, 2025, all new quotes will reflect the above changes. Orders received and confirmed on or before March 31, 2025, will not be subject to the surcharge.",
  },
  {
    SearchText: "Arctic Air / Broich",
    Discount: 1 / 3,
    // https://caseparts.slack.com/archives/C07F530PZT3/p1762983549312779
    //Tariff: "They went back down to the 10% tariff charge,  Applies to all orders for units, parts, and accessories"
  },
  {
    SearchText: "Arctic Air / Coast Appliance",
    Discount: 0.2841,
    //Tariff: "30% Tariff charge in effect. Increased from 10%. Applies to all orders for units, parts, and accessories"
  },
  {
    SearchText: "Arctic Air / Encompass aka Dayton",
    Discount: 0.396,
    //Tariff: "30% Tariff charge in effect. Increased from 10%. Applies to all orders for units, parts, and accessories"
  },
  {
    SearchText: "Arctic Cooling System",
    Discount: 0.2,
  },
  {
    SearchText: "Arctic Industries",
    Discount: 0.0
  },
  {
    SearchText: "Ardco",
    Discount: 0.5,
  },
  {
    SearchText: "Arneg USA",
    Discount: 0.5,
    ShainaNote: "They do not disclose the percentage to customers"
  },
  {
    SearchText: "Avantco / Clark Service Group",
    Discount: 0.2,
  },
  {
    SearchText: "Bally",
    Discount: 0.5,
    PromptForListPrice: true,
  },
  {
    SearchText: "Barker Specialty Prod / Arctic Cooling Systems",
    Discount: 0.15
  },
  {
    SearchText: "Bastian Blessing / EMCO",
    Discount: 0.25,
    PromptForListPrice: true,
  },
  {
    SearchText: "Berner",
    Discount: 0.35
  },
  {
    SearchText: "Beverage Air",
    Discount: 0.55,
    PromptForListPrice: true,
  },
  {
    SearchText: "Beverage Air -- DROPSHIPS",
    MinOrder: "$200",
    Discount: 0.55,
    PromptForListPrice: true,
  },
  {
    SearchText: "Birmingham",
    Discount: 0.5,
    ShainaNote: "No specific discount, we get dealer pricing",
    UpdateDate: "2026-04-20"
  },
  {
    SearchText: "Bison / JMC Furniture",
    Discount: 0.2
  },
  {
    SearchText: "Blue Air",
    Discount: 0.73,
  },
  {
    SearchText: "Bohn / Heatcraft / Thompson Suppy",
    Discount: 1 - 0.51063,
  },
  {
    SearchText: "Carroll Coolers / Leer",
    Discount: 0.0
  },
  {
    SearchText: "Centaur / Hagar Parts & Service",
    Discount: 0.25
  },
  {
    SearchText: "Century Refrigeration / RAE Corporation",
    Discount: 0.5,
    ShainaNote: "No specific discount, we get wholesaler pricing"
  },
  {
    SearchText: "Chase Door",
    Discount: 0.5,
    ShainaNote: "No specific discount, we get dealer pricing"
  },
  {
    SearchText: "Chill Rite",
    Discount: 0.5,
    ShainaNote: "per brooke: There is no discount, but you get the lowest prices we offer, as we do not sell to the public or charge taxes. If you buy our parts from a distributor they are priced significantly higher."
  },
  {
    SearchText: "Coldzone / HTPG (for Equipment Only)",
    MinOrder: "$50",
    Discount: 0.79,
    PromptForListPrice: true,
  },
  {
    SearchText: "Coldzone / HTPG (for Parts Orders Only)",
    MinOrder: "$50",
    Discount: 0.692,
    PromptForListPrice: true,
  },  {
    SearchText: "Columbus Showcase / Global Showcase",
    Discount: 0.0,
    UpdateDate: "2025-06-26"
  },
  {
    SearchText: "Commercial Refrigeration Company",
    Discount: 0.3,
  },
  {
    SearchText: "Commercial Refrigerator Door / Styleline Systems",
    Discount: 0.4,
    UpdateDate: "2025-06-26"
  },
  {
    SearchText: "Component Hardware",
    Discount: 0.475,
  },
  {
    SearchText: "Component HDW",
    Discount: 0.5,
    ShainaNote: "no flat % discount, Different items have different discounts.",
    UpdateDate: "2025-06-26"
  },
  {
    SearchText: "Continental",
    Discount: 0.4,
  },
  {
    SearchText: "Cospolich",
    Discount: 0.0,
    UpdateDate: "2025-06-26"
  },
  {
    SearchText: "CrownTonka / Everidge",
    Discount: 0.0,
    UpdateDate: "2025-07-02"
  },
  {
    SearchText: "Cutting Boards / Gordon Plastics",
    Discount: 0.0,
    UpdateDate: "2025-07-02"
  },
  {
    SearchText: "DisplayRite / Commercial Display System",
    Discount: 0.6,
    UpdateDate: "2025-06-26"
  },
  {
    SearchText: "Duracool / Kolpak",
    Discount: 0.5,
    UpdateDate: "2025-06-26"
  },
  {
    SearchText: "EconoCold / RMI",
    Discount: 0.5,
    UpdateDate: "2025-07-03"
  },
  {
    SearchText: "Electro Freeze / Commercial Kitchen",
    Discount: 0.25,
  },
  {
    SearchText: "Electro Freeze / F. E. A. Service",
    Note: "They do not support drop shipments",
    Discount: 0.3,
  },
  {
    SearchText: "Eliason / Chase Doors",
    Discount: 0.5,
    ShainaNote: "No specific discount, we get dealer pricing",
    UpdateDate: "2025-06-26"
  },
  {
    SearchText: "Entrée / Hagar Parts",
    Discount: 0.25,
  },
  {
    SearchText: "Everest",
    Discount: 0.65,
  },
  {
    SearchText: "Fogel USA",
    MinOrder: "$20.00",
    Discount: 0.5,
  },
  {
    SearchText: "Follett",
    Discount: 0.19,
  },
  {
    SearchText: "Forma Kool",
    Discount: 0.0,
    UpdateDate: "2025-06-26"
  },
  {
    SearchText: "Foster",
    Discount: 0.25,
    PromptForListPrice: true,
  },
  {
    SearchText: "Frank Door",
    MinOrder: "$25",
    Discount: 0.2,
  },
  {
    SearchText: "Frigoglass / Excellence Industries",
    Discount: 0.2,
    UpdateDate: "2025-06-26"
  },
  {
    SearchText: "Frigoglass / Stajac / Excellence Industries",
    // 10/23/24 Reduced discount from 35% to 20% per Shaina
    // https://caseparts.slack.com/archives/CQUC95QF9/p1729689673536539
    Discount: 0.2,
  },
  {
    SearchText: "German Knife",
    Discount: 0.0,
    UpdateDate: "2025-06-26"
  },
  {
    SearchText: "Glass DR Solutions / DDS Cisaplast",
    Discount: 0.5,
    ShainaNote: "No spefic % discount but we get the preferred pricing",
    UpdateDate: "2025-06-26"
  },
  {
    SearchText: "Glastender",
    Discount: 0.55,
    EndUserMarkup: 1 / 0.45,
    DealerMarkup: 0.75 / 0.45,
    WholesalerMarkup: 0.7 / 0.45,
    PromptForListPrice: true,
    HasCustomMarkups: true
  },
  {
    SearchText: "H & K Resupply",
    Discount: 0.5,
    ShainaNote: "They aren't sure, veronica says different parts have different discounts,  but based off what PT shows as list, its about 45-50% off",
    UpdateDate: "2025-06-26"
  },
  {
    SearchText: "Harford / Kolpak",
    Discount: 0.5,
    UpdateDate: "2025-06-26"
  },
  {
    SearchText: "Hill / Arctic Cooling Systems",
    Discount: 0.15,
    UpdateDate: "2025-06-26"
  },
  {
    SearchText: "Hill Phoenix Walk-In / Arctic Cooling Systems",
    Discount: 0.15,
    UpdateDate: "2025-06-26"
  },
  {
    SearchText: "HK International",
    Discount: 0.5,
  },
  {
    SearchText: "Hobart",
    Discount: 0.5,
    PromptForListPrice: true,
  },
  {
    SearchText: "Hobart  -- DROPSHIPS",
    Discount: 0.44,
    PromptForListPrice: true,
  },
  {
    SearchText: "Hoshizaki Western",
    Discount: 0.15,
  },
  {
    SearchText: "Howard / Mccray",
    Discount: 0.5,
  },
   {
    SearchText: "Heat Transfer Products Group (for Equipment Only)",
    MinOrder: "$50",
    Discount: 0.79,
    PromptForListPrice: true,
  },
  {
    SearchText: "Heat Transfer Products Group (for Parts Orders Only)",
    MinOrder: "$50",
    Discount: 0.692,
    PromptForListPrice: true,
  },
  {
    SearchText: "Russell Coil / HTPG (for Equipment Only)",
    MinOrder: "$30",
    Discount: 0.79,
    PromptForListPrice: true,
  },
  {
    SearchText: "Russell Coil / HTPG (for Parts Orders Only)",
    MinOrder: "$30",
    Discount: 0.692,
    PromptForListPrice: true,
  },
  {
    SearchText: "Hussmann / Fazio",
    Discount: 0.19618,
  },
  {
    SearchText: "Hussmann / OEM",
    Discount: 0.1,
  },
  {
    SearchText: "Hydra Cool / RNJ",
    Discount: 0.3,
  },
    {
    SearchText: "IDW",
    Discount: 0.0,
    UpdateDate: "2026-02-04",
    Tariff: "IDW is implementing a 20% supply chain surcharge on all orders."
  },
  {
    SearchText: "Ikon / Mvp Group",
    MinOrder: "$50",
    Discount: 0.3,
  },
  {
    SearchText: "Imbera / Nordon Cooler Solutions",
    Discount: 0.3,
    UpdateDate: "2025-06-26"
  },
  {
    SearchText: "Infrico Usa",
    Discount: 0.5,
    PromptForListPrice: true,
  },
  {
    SearchText: "International Cold Storage / Everidge",
    Discount: 0,
  },
  {
    SearchText: "International Door Closer / Huntington Hardware Co",
    Discount: 0.0,
    UpdateDate: "2025-06-26"
  },
  {
    SearchText: "Jamison Door Company",
    Discount: 0.15,
  },
  {
    SearchText: "Jet Tech / RNJ Commercial Parts",
    Discount: 0.3,
    UpdateDate: "2025-06-26"
  },
  {
    SearchText: "Jewett / Thermo Fisher Scientific",
    Discount: 0.0,
    UpdateDate: "2025-06-26"
  },
  {
    SearchText: "Kairak",
    Discount: 0.5,
    PromptForListPrice: true,
  },
  {
    SearchText: "Kairak  -- DROPSHIPS",
    Discount: 0.44,
    PromptForListPrice: true,
  },
  {
    SearchText: "Kason",
    Discount: 0.5,
  },
  {
    SearchText: "Kelvinator / Don Stevens",
    Discount: 0.18,
    PromptForListPrice: true,
  },
  {
    SearchText: "Kelvinator / Global",
    Discount: 0.5725,
    PromptForListPrice: true,
  },
  {
    SearchText: "Kelvinator / Global -- DROPSHIPS",
    Discount: 0.5,
    PromptForListPrice: true,
  },
  {
    SearchText: "Killion",
    Discount: 0.0,
    UpdateDate: "2025-06-26"
  },
  {
    SearchText: "Kolpak",
    MinOrder: "$100 - and below min they add an extra $25",
    Discount: 0.5,
    PromptForListPrice: true,
  },
  {
    SearchText: "Kool-It / RNJ Commercial Parts",
    Discount: 0.3,
    UpdateDate: "2025-06-26"
  },
  {
    SearchText: "Krack Coil / Fazio",
    Discount: 0.3,
  },
  {
    SearchText: "Kratos / Central Restaurant Products",
    Discount: 0.5,
    ShainaNote: "No specific discount per chris",
    UpdateDate: "2025-06-26"
  },
  {
    SearchText: "Kysor / Warren",
    Discount: 1 - 0.35715,
  },
  {
    SearchText: "Kysor Panel / KPS Global",
    Discount: 0.5,
  },
  {
    SearchText: "La Rosa",
    Discount: 0.25,
    UpdateDate: "2025-06-26"
  },
  {
    SearchText: "LabRepCo / Horizon Scientific",
    Discount: 0.0,
    UpdateDate: "2025-06-26"
  },
  {
    SearchText: "Larkin / United Refrigeration",
    Discount: 0.5,
    Note: "Close to 50% per Glenn, they quote our cost",
    UpdateDate: "2025-06-26"
  },
  {
    SearchText: "Leer (Ice Merch)",
    Discount: 0.25,
    PromptForListPrice: true,
  },
  {
    SearchText: "Leer (Walk-Ins)",
    Discount: 0.0,
    PromptForListPrice: true,
  },
  {
    SearchText: "Leer Ice",
    Discount: 0.25,
    UpdateDate: "2025-06-26"
  },
  {
    SearchText: "Leer Walk-Ins",
    Discount: 0.0,
    UpdateDate: "2025-06-26"
  },
  {
    SearchText: "Louisville Cooler",
    Discount: 0.0,
    UpdateDate: "2025-06-26"
  },
  {
    SearchText: "Marvel aka AGA Marvel",
    Discount: 0.3,
  },
  {
    SearchText: "Micro Matic USA / Nordon",
    Discount: 0.5,
  },
  {
    SearchText: "Migali",
    Discount: 0.5,
  },
  {
    SearchText: "Minus Forty",
    Discount: 0.2,
    Tariff: "Anything from China will have a 145% Tariff, Steel and Aluminum has a 25% tariff."
  },
  {
    SearchText: "Mod-U-Serve",
    Discount: 0.5,
  },
  {
    SearchText: "Montague",
    Discount: 0.5,
    PromptForListPrice: true,
  },
  {
    SearchText: "MTL Tech / Fenyx Technologies",
    Discount: 0.0,
    UpdateDate: "2025-06-26"
  },
  {
    SearchText: "Nelson aka C. Nelson",
    Discount: 0.55,
  },
  {
    SearchText: "Norlake Scientific / Horizon Scientific",
    Discount: 0.0,
    Note: "0% they do not give discounts",
    UpdateDate: "2025-06-26"
  },
  {
    SearchText: "Norris",
    Discount: 0.4,
  },
  {
    SearchText: "Northland",
    Discount: 0.4,
  },
  {
    SearchText: "Omni Temp / Team",
    Discount: 0.5,
  },
  {
    SearchText: "Peerless",
    MinOrder: "$100",
    Discount: 0.36,
    Tariff: "Tariffs Currently in Effect:\nChinese tariff applying +10% + 10% = 20% - Effective 3/4/25\nCopper Tarrif Applying +25% - Effective 3/12/25\nAluminum tariff applying +25% - Effective 3/12/25"
  },
  {
    SearchText: "Pike / Anthony International",
    Discount: 0.5,
    UpdateDate: "2025-07-03"
  },
  {
    SearchText: "Polar Temp / Southeast Cooler",
    Discount: 0.0,
    UpdateDate: "2025-06-26"
  },
  {
    SearchText: "Powers Equipment",
    Discount: 0.5,
  },
  {
    SearchText: "PRO-KOLD / TorRey Refrigeration",
    Discount: 0.4,
    UpdateDate: "2025-06-26"
  },
  {
    SearchText: "Revco / Thermo Fisher Scientific",
    Discount: 0.0,
    UpdateDate: "2025-06-26"
  },
  {
    SearchText: "Serv-Ware",
    Discount: 0.5,
    UpdateDate: "2025-07-03"
  },
  {
    SearchText: "Seville Display Doors",
    Discount: 0.5,
    Note: "No specific %, we are in tier 1 though with the best discount",
    UpdateDate: "2025-06-26"
  },
  {
    SearchText: "Silver King / Marmonlink",
    Discount: 0.25,
    PromptForListPrice: true,
  },
  {
    SearchText: "Southern Case Arts",
    Discount: 0.5,
    MinOrder: "$20.00 MINIMUM ** WE SHOULD ALWAYS DROP SHIP FROM HERE BECAUSE THEY CHARGE US A $20.00 FEE ON ALL ORDERS PLUS FREIGHT",
    Tariff: "Standard Tariff fee of 7.4% for all parts"
  },
  {
    SearchText: "Southern Stainless",
    Discount: 0.0,
    UpdateDate: "2025-06-26"
  },
  {
    SearchText: "Southern Store Fixtures",
    Discount: 0.5,
    MinOrder: "$20.00 MINIMUM ** WE SHOULD ALWAYS DROP SHIP FROM HERE BECAUSE THEY CHARGE US A $20.00 FEE ON ALL ORDERS PLUS FREIGHT",
    Tariff: "Standard Tariff fee of 7.4% for all parts"
  },
  {
    SearchText: "Spartan (JMCFoodEquipment)",
    Discount: 0.2,
    PromptForListPrice: true,
  },
  {
    SearchText: "Stanley Knight / Traulsen",
    Discount: 0.5,
    PromptForListPrice: true,
  },
  {
    SearchText: "Stanley Knight / Traulsen -- DROPSHIPS",
    Discount: 0.44,
    PromptForListPrice: true,
  },
  {
    SearchText: "Strip Curtains via Kason",
    Discount: 0.5,
  },
  {
    SearchText: "Styleline Systems / Commercial Refr",
    Discount: 0.4,
  },
  {
    SearchText: "Tafco",
    Discount: 0.5,
    Note: "0% , they sell at Wholesale prices",
    UpdateDate: "2025-06-26"
  },
  {
    SearchText: "Taylor / Midwest Equipment Co.",
    Discount: 0.1,
    UpdateDate: "2025-06-26"
  },
  {
    SearchText: "Thermalrite / Everidge",
    Discount: 0,
  },
  {
    SearchText: "Thermo Fisher Scientific",
    Discount: 0.0,
    UpdateDate: "2025-06-26"
  },
  {
    SearchText: "Thermo-Kool",
    Discount: 0.5,
  },
  {
    SearchText: "Tor-Rey",
    Discount: 0.4,
    UpdateDate: "2025-06-26"
  },
  {
    SearchText: "Traulsen",
    Discount: 0.5,
    PromptForListPrice: true,
  },
  {
    SearchText: "Traulsen -- DROPSHIPS",
    Discount: 0.44,
    PromptForListPrice: true,
  },
  {
    SearchText: "Trenton / United Refrigeration",
    Discount: 0.5,
    Note: "Close to 50% per Glenn, they quote our cost",
    UpdateDate: "2025-06-26"
  },
  {
    SearchText: "True Mfg",
    Discount: 0.64,
    EndUserMarkup: 2.0,
    DealerMarkup: 1.5,
    WholesalerMarkup: 1.43
  },
  {
    SearchText: "Turbo Air",
    Discount: 0.7,
    PromptForListPrice: true,
  },
  {
    SearchText: "Turbo Air Conditioning",
    Discount: 0.0,
    PromptForListPrice: true,
  },
  {
    SearchText: "Turbo Coil / The Montague Company",
    Discount: 0.5,
    UpdateDate: "2025-06-26"
  },
  {
    SearchText: "Tyler / Arctic Cooling Systems",
    Discount: 0.15,
    UpdateDate: "2025-06-26"
  },
  {
    SearchText: "Tyler Walk-Ins / International Cold Storage",
    Discount: 0.0,
    UpdateDate: "2025-06-26"
  },
  {
    SearchText: "U-Line",
    Discount: 0.25,
  },
  {
    SearchText: "U-Star / The LegacyCompany",
    Discount: 0.5,
    UpdateDate: "2025-06-26"
  },
  {
    SearchText: "US Cooler / Area Wide Mechanical",
    Discount: 0.4,
    UpdateDate: "2025-07-03"
  },
  {
    SearchText: "Universal Nolan / Global",
    Discount: 0.5725,
    PromptForListPrice: true,
  },
  {
    SearchText: "Universal Nolan / Global -- DROPSHIPS",
    Discount: 0.5,
    PromptForListPrice: true,
  },
  {
    SearchText: "Utility",
    Discount: 0.5,
  },
  {
    SearchText: "Vering / Seville Display Doors",
    Discount: 0.5,
    Note: "No specific %, we are in tier 1 though with the best discount",
    UpdateDate: "2025-06-26"
  },
  {
    SearchText: "Victory",
    Discount: 0.55,
    PromptForListPrice: true,
  },
  {
    SearchText: "Vortex",
    Discount: 0.0,
    UpdateDate: "2025-06-26"
  },
  {
    SearchText: "WA Brown / Imperial Brown",
    Discount: 0.0,
    UpdateDate: "2025-06-26"
  },
  {
    SearchText: "Witt / HTPG (for Equipment Only)",
    MinOrder: "$50",
    Discount: 0.79,
    PromptForListPrice: true,
  },
  {
    SearchText: "Witt / HTPG (for Parts Orders Only)",
    MinOrder: "$50",
    Discount: 0.692,
    PromptForListPrice: true,
  },
  {
    SearchText: "Zero Zone",
    Discount: 0.495,
    EndUserMarkup: 1 / (1 - 0.495),
    DealerMarkup: 1.65,
    WholesalerMarkup: 1.6,
    PromptForListPrice: true,
    HasCustomMarkups: true
  }
];

export default vendors;